import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Avis} from 'src/app/models/avis';
import * as jsonColsLister from '../../../../assets/dynamic/lister/tableCols.json';
import {Endpoints} from '../../../models/endpoints';
import {TableContent} from '../../shared/generic/components/tableau/model/table.content';
import {TableActionService} from '../../shared/generic/components/tableau/services/table.action.service';
import {ListerAvisMessages} from '../../shared/models/component-messages/lister-avis-messages';
import {HttpService} from '../../shared/services/http.service';
import {LogService} from '../../shared/services/log.service';
import {AvisItem} from './model/avis.item';
import {CanNavigateInStepperService} from '../../shared/services/can-navigate-in-stepper.service';
import {SessionService} from '../../administration/services/session.service';
import {AutoCompleteService} from '../../shared/services/auto-complete.service';
import {Title} from '@angular/platform-browser';
import {EformsSubjectService} from '../../formulaires/eforms/services/eforms-subject.service';
import {TranslateService} from '@ngx-translate/core';
import {StatutAvisEnum} from '../../../models/enums/statut-avis.enum';
import {BehaviorSubject} from 'rxjs';
import {StepperBuilderService} from '../creer/services/stepper.builder.service';
import {AvisService} from '../services/avis-service';
import {AvisDataTransferService} from '../../shared/services/avis-data-transfer.service';
import {SpinnerVisibilityService} from 'ng-http-loader';
import {EnumMicroDroits} from '../../administration/models/micro.droits';
import {first} from 'rxjs/operators';
import {AuthorizationService} from '../../../authorization/services/authorization.service';

@Component({
  selector: 'app-lister-avis-de-pub',
  templateUrl: './lister-avis-de-pub.component.html',
  styleUrls: ['./lister-avis-de-pub.component.scss']
})
export class ListerAvisDePubComponent implements OnInit {

  private LOG: LogService = new LogService(ListerAvisDePubComponent);

  hasManageRight: boolean;
  public listerAvisMessages = new ListerAvisMessages();
  public tableContent: TableContent;
  public sortingColumn = {name: 'datedemodification', start: 'desc'};
  totalItems = 0;
  public choosenStatus: string = null;
  public enableFilter = false;
  // Tant que true, le bouton "Créer" et la table restent masqués derrière un écran de
  // chargement pour éviter d'arriver sur un tableau vide le temps que les données chargent.
  public isLoading = true;

  public buttons = [
    {value: 'Avis en cours', active: false, code: 'ENCOURS'},
    {value: 'Avis publiés', active: false, code: 'PUBLIES'},
    {value: 'Avis refusés', active: false, code: 'REFUSES'},
  ];

  constructor(private tableActionService: TableActionService,
              private http: HttpService,
              private session: SessionService,
              private canNavigateInStepperService: CanNavigateInStepperService,
              // appel du constructor AutoCompleteService pour initialisation des listes cpv, nuts etc
              private autoCompleteService: AutoCompleteService,
              private titleService: Title, private httpClient: HttpService,
              private eformsSubjectService: EformsSubjectService,
              private translateService: TranslateService,
              private stepperBuilderService: StepperBuilderService,
              private avisService: AvisService, private avisDataTransferService: AvisDataTransferService,
              private spinner: SpinnerVisibilityService, private authorizationService: AuthorizationService,
              private activatedRoute: ActivatedRoute) {
  }


  public ngOnInit() {
    this.spinner.show();
    this.tableContent = new TableContent();
    this.tableContent.displayedCols = ['numero', 'avisLie', 'referencedelaconsultation', 'typedemarche', 'intituledeformulaire',
      'typeAvis', 'statut', 'datedemodification', 'datedenvoi', 'datedepublication', 'supportdediffusion', 'action'];
    this.tableContent.tableCols = jsonColsLister.table;
    this.tableContent.uniqueKey = 'numero';
    this.canNavigateInStepperService.setReferenceParent(null);
    this.canNavigateInStepperService.selectedDiffuseurInitial = [];
    this.canNavigateInStepperService.linkableForms = null;
    this.canNavigateInStepperService.linkableNotices = [];
    this.canNavigateInStepperService.formulairevalues = null;
    this.stepperBuilderService.PDFAvisLiesSetted = new BehaviorSubject(null);
    this.canNavigateInStepperService.isEdit = false;

    // Optimisation : Détecter si on vient d'un décrochage depuis PLACE
    // pour éviter la requête initiale inutile qui récupère tous les avis
    const fromPlace = this.activatedRoute.snapshot.queryParams['fromPlace'];
    const reference = this.activatedRoute.snapshot.queryParams['ref'];

    if (fromPlace === 'true' && reference) {
      // Décrochage depuis PLACE : charger directement les avis filtrés par référence de consultation
      // Cela évite de charger tous les avis du silo puis de les filtrer ensuite (gain de ~60% sur le temps de chargement)
      this.canNavigateInStepperService.reference = reference;
      this.retrieveItemsWithFilter(reference);
    } else {
      // Navigation normale : charger tous les avis du silo (comportement par défaut)
      this.retrieveItems(this.translateService);
    }

    this.titleService.setTitle('Avis de publicité - Liste des avis de publicité');
    this.setChangeCorrigJustification();
    this.habilitations();
  }

  /**
   * Récupère les avis filtrés par référence de consultation lors d'un décrochage depuis PLACE.
   * Cette méthode évite la requête initiale inutile qui charge tous les avis du silo.
   * @param reference - Référence de consultation depuis PLACE
   */
  retrieveItemsWithFilter(reference: string) {
    const url = Endpoints.AVIS_FIND_ALL +
      Endpoints.ADMIN_SIRET + this.session.getUser()?.siret +
      Endpoints.ADMIN_SERVICE + this.session.getUser()?.service +
      Endpoints.AVIS_LIES + true +
      '&page=' + this.avisDataTransferService.page +
      '&pageSize=' + this.avisDataTransferService.pageSize +
      '&filter=' + encodeURIComponent(reference) +
      '&sortColumn=' + this.sortingColumn.name +
      '&sortOrder=' + this.sortingColumn.start;

    this.http.get(url).subscribe({
      next: (data: any) => {
        this.populateDataTable(data);
        this.stopLoading();
      },
      error: error => this.LOG.error(error),
      // HttpService ne complète jamais l'appel en cas de succès (il désabonne la requête interne
      // juste après le next) ; en cas d'échec HTTP en revanche il affiche un toast et termine l'appel
      // sans next ni error (cf. tableau.component.ts:getStatusInfo) : complete couvre donc ce cas-là.
      complete: () => this.stopLoading()
    });
  }

  retrieveItems(translateService: any) {
    this.http.get(
      Endpoints.AVIS_FIND_ALL +
      Endpoints.ADMIN_SIRET +
      this.session.getUser()?.siret +
      Endpoints.ADMIN_SERVICE +
      this.session.getUser()?.service +
      Endpoints.AVIS_LIES +
      true + '&page=' + this.avisDataTransferService.page + '&pageSize=' + this.avisDataTransferService.pageSize +
      '&sortColumn=' + this.sortingColumn.name + '&sortOrder=' + this.sortingColumn.start
    ).subscribe({
      next: (data: any) => {
        this.populateDataTable(data);
        this.stopLoading();
      },
      error: error => this.LOG.error(error),
      complete: () => this.stopLoading()
    });
  }

  private stopLoading() {
    this.spinner.hide();
    this.isLoading = false;
  }

  public getActionEvent(event) {
    this.tableActionService.getAction(event).subscribe(data => {
      if (data) {
        if (event.action.type === 'Supprimer') {
          this.filterWithStatus(this.choosenStatus !== null);
        } else {
          this.retrieveItems(this.translateService);
        }
      }
    });
  }

  private setChangeCorrigJustification() {
    if (this.eformsSubjectService.changeCorrigJustification.value.length === 0) {
      this.httpClient
        .get('assets/dynamic/creer/formSections/E_FORM_1.json', null, {basePath: ''})
        .subscribe((data: any) => {
          let listJustification: string[];
          const newObj: any = data.content?.filter((value: any) => {
            return value.id.indexOf('GR-Change') != -1 ? value : null;
          });
          let newObj2: any = null;
          if (newObj) {
            newObj2 = newObj[0].content?.filter((value: any) => {
              return value.id.indexOf('BT-140-notice') != -1 ? value : null;
            });
          }
          listJustification = newObj2 !== null ? newObj2[0].codeList : [];
          this.eformsSubjectService.changeCorrigJustification.next(listJustification);
        });
    }
  }

  public setAvisStatusFilter(index: number) {
    switch (index) {
      case 0:
        this.buttons[0].active = !this.buttons[0].active;
        this.buttons[1].active = false;
        this.buttons[2].active = false;
        break;
      case 1:
        this.buttons[1].active = !this.buttons[1].active;
        this.buttons[0].active = false;
        this.buttons[2].active = false;
        break;
      case 2:
        this.buttons[1].active = false;
        this.buttons[0].active = false;
        this.buttons[2].active = !this.buttons[2].active;
        break;
    }
    this.choosenStatus = this.buttons[index].active ? this.buttons[index].code : null;
    this.enableFilter = this.buttons[index].active;
    this.filterWithStatus(this.enableFilter);
  }

  public filterWithStatus(enableFilter: boolean) {
    this.avisService.filterWithStatus(this.choosenStatus, this.session.getUser()?.siret,
      this.session.getUser()?.service, this.avisDataTransferService.page,
      this.avisDataTransferService.pageSize, this.sortingColumn.name, this.sortingColumn.start, enableFilter)
      .subscribe((data: any) => {
        this.populateDataTable(data);
      });
  }

  public populateDataTable(data: any) {
    const resultArray = data.avis.map(item => {
      const avis: Avis = item;
      const avisItem: AvisItem = new AvisItem();
      avisItem.datedecreation = avis.dateCreation;
      avisItem.datedemodification = avis.dateModification;
      avisItem.numero = avis.reference;
      avisItem.avisId = avis.avisId;
      avisItem.referencedelaconsultation = avis.refConsultation;
      avisItem.statut = StatutAvisEnum[avis.statut];
      avisItem.typeAvis = avis.critere?.typeAvis.libelle;
      avisItem.typedemarche = avis.intituleDuMarche ?? avis.critere?.typeMarche.libelle;
      avisItem.formulairecode = avis.formulaire.code;
      avisItem.norme = avis.formulaire.typeNorme;
      avisItem.intituledeformulaire = avis.formulaire.intitule;
      avisItem.raisonSociale = avis.user?.raisonSociale;
      avisItem.service = avis.user?.service;
      avisItem.motif = avis.motifModification ? 'eform-not-editable.code|name|change-corrig-justification.' + avis.motifModification : null;
      if (avisItem.motif) {
        avisItem.intituledeformulaire = avisItem.intituledeformulaire + ' | ' + this.translateService.instant(avisItem.motif);
      }
      avisItem.isLie = avis.refAvisLie !== undefined && avis.refAvisLie !== null && avis.refAvisLie !== '';
      avisItem.hasAvisLies = avis.hasAvisLies ?? false;
      if (avis.flux != null) {
        avisItem.urlBoamp = avis.flux[0]?.fluxBoamp?.urlBoamp;
        avisItem.datedepublication = avis.flux[0]?.fluxBoamp?.datePublicationBoamp ?? avis.flux[0]?.fluxBoamp?.datePublicationJoue ?? null;
        avisItem.datedenvoi = avis.flux[0]?.dateEmission;
        avisItem.formulairevalues = {
          idweb: avis.flux[0]?.fluxBoamp?.idJoue,
          datePublication: avis.flux[0]?.fluxBoamp?.datePublicationBoamp ?? avis.flux[0]?.fluxBoamp?.datePublicationJoue ?? null
        };
        avisItem.diffuseurs = avis.flux.map(flux => flux.id?.diffuseurId).filter((el, i, a) => i === a.indexOf(el));
        avisItem.supportdediffusion = avis.flux.map(flux => flux.id?.supportDiffusion).filter((el, i, a) => i === a.indexOf(el));
        avisItem.eformIdParentNotice = avis.eformIdParentNotice;
      }
      return avisItem;
    });
    this.tableContent.tableData.next(resultArray);
    this.totalItems = data.totalItems;
  }

  public changeSortColumnEvent(event) {
    this.sortingColumn = {name: event.active, start: event.direction};
  }

  private habilitations() {
    this.authorizationService.hasAnyMicroRightIn(Array.of(EnumMicroDroits.AVIS_PUBLICITE_GESTION))
      .pipe(first())
      .subscribe(hasManageRight => { this.hasManageRight = hasManageRight; });
  }
}

